/* AUTO-GENERATED — DO NOT EDIT BY HAND */
export const functions = {
  EPDF_GetMetaKeyCount: [['number', 'boolean'] as const, 'number'] as const,
  EPDF_GetMetaKeyName: [
    ['number', 'number', 'boolean', 'number', 'number'] as const,
    'number',
  ] as const,
  EPDF_GetMetaTrapped: [['number'] as const, 'number'] as const,
  EPDF_GetPageRotationByIndex: [['number', 'number'] as const, 'number'] as const,
  EPDF_GetPageSizeByIndexNormalized: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDF_HasMetaText: [['number', 'string'] as const, 'boolean'] as const,
  EPDF_IsEncrypted: [['number'] as const, 'boolean'] as const,
  EPDF_IsOwnerUnlocked: [['number'] as const, 'boolean'] as const,
  EPDF_LoadPageNormalized: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDF_PNG_EncodeRGBA: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  EPDF_RemoveEncryption: [['number'] as const, 'boolean'] as const,
  EPDF_RenderAnnotBitmap: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  EPDF_RenderAnnotBitmapUnrotated: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  EPDF_SetEncryption: [['number', 'string', 'string', 'number'] as const, 'boolean'] as const,
  EPDF_SetMetaText: [['number', 'string', 'number'] as const, 'boolean'] as const,
  EPDF_SetMetaTrapped: [['number', 'number'] as const, 'boolean'] as const,
  EPDF_UnlockOwnerPermissions: [['number', 'string'] as const, 'boolean'] as const,
  EPDFAction_CreateGoTo: [['number', 'number'] as const, 'number'] as const,
  EPDFAction_CreateGoToNamed: [['number', 'string'] as const, 'number'] as const,
  EPDFAction_CreateLaunch: [['number', 'number'] as const, 'number'] as const,
  EPDFAction_CreateRemoteGoToByName: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFAction_CreateRemoteGoToDest: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFAction_CreateURI: [['number', 'string'] as const, 'number'] as const,
  EPDFAnnot_ApplyRedaction: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_ClearColor: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_Flatten: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GenerateAppearance: [['number'] as const, 'boolean'] as const,
  EPDFAnnot_GenerateAppearanceWithBlend: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetAPMatrix: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetAvailableAppearanceModes: [['number'] as const, 'number'] as const,
  EPDFAnnot_GetBlendMode: [['number'] as const, 'number'] as const,
  EPDFAnnot_GetBorderDashPattern: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetBorderDashPatternCount: [['number'] as const, 'number'] as const,
  EPDFAnnot_GetBorderEffect: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetBorderStyle: [['number', 'number'] as const, 'number'] as const,
  EPDFAnnot_GetColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  EPDFAnnot_GetDefaultAppearance: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  EPDFAnnot_GetExtendedRotation: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetIcon: [['number'] as const, 'number'] as const,
  EPDFAnnot_GetIntent: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFAnnot_GetLineEndings: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetOpacity: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetOverlayText: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFAnnot_GetOverlayTextRepeat: [['number'] as const, 'boolean'] as const,
  EPDFAnnot_GetRect: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetRectangleDifferences: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  EPDFAnnot_GetReplyType: [['number'] as const, 'number'] as const,
  EPDFAnnot_GetRichContent: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFAnnot_GetRotate: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetTextAlignment: [['number'] as const, 'number'] as const,
  EPDFAnnot_GetUnrotatedRect: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_GetVerticalAlignment: [['number'] as const, 'number'] as const,
  EPDFAnnot_SetAction: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetAPMatrix: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetBorderDashPattern: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetBorderStyle: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  EPDFAnnot_SetDefaultAppearance: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  EPDFAnnot_SetExtendedRotation: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetIcon: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetIntent: [['number', 'string'] as const, 'boolean'] as const,
  EPDFAnnot_SetLine: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetLineEndings: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetLinkedAnnot: [['number', 'string', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetOpacity: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetOverlayText: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetOverlayTextRepeat: [['number', 'boolean'] as const, 'boolean'] as const,
  EPDFAnnot_SetReplyType: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetRotate: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetTextAlignment: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetUnrotatedRect: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetVerticalAlignment: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_SetVertices: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFAnnot_UpdateAppearanceToRect: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAttachment_GetDescription: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFAttachment_GetIntegerValue: [['number', 'string', 'number'] as const, 'boolean'] as const,
  EPDFAttachment_SetDescription: [['number', 'number'] as const, 'boolean'] as const,
  EPDFAttachment_SetSubtype: [['number', 'string'] as const, 'boolean'] as const,
  EPDFBookmark_AppendChild: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFBookmark_Clear: [['number'] as const, 'boolean'] as const,
  EPDFBookmark_ClearTarget: [['number'] as const, 'boolean'] as const,
  EPDFBookmark_Create: [['number', 'number'] as const, 'number'] as const,
  EPDFBookmark_Delete: [['number', 'number'] as const, 'boolean'] as const,
  EPDFBookmark_InsertAfter: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  EPDFBookmark_SetAction: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFBookmark_SetDest: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFBookmark_SetTitle: [['number', 'number'] as const, 'boolean'] as const,
  EPDFCatalog_GetLanguage: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFDest_CreateRemoteView: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  EPDFDest_CreateRemoteXYZ: [
    ['number', 'number', 'boolean', 'number', 'boolean', 'number', 'boolean', 'number'] as const,
    'number',
  ] as const,
  EPDFDest_CreateView: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  EPDFDest_CreateXYZ: [
    ['number', 'boolean', 'number', 'boolean', 'number', 'boolean', 'number'] as const,
    'number',
  ] as const,
  EPDFNamedDest_Remove: [['number', 'string'] as const, 'boolean'] as const,
  EPDFNamedDest_SetDest: [['number', 'string', 'number'] as const, 'boolean'] as const,
  EPDFPage_ApplyRedactions: [['number'] as const, 'boolean'] as const,
  EPDFPage_CreateAnnot: [['number', 'number'] as const, 'number'] as const,
  EPDFPage_GetAnnotByName: [['number', 'number'] as const, 'number'] as const,
  EPDFPage_GetAnnotCountRaw: [['number', 'number'] as const, 'number'] as const,
  EPDFPage_GetAnnotRaw: [['number', 'number', 'number'] as const, 'number'] as const,
  EPDFPage_RemoveAnnotByName: [['number', 'number'] as const, 'boolean'] as const,
  EPDFPage_RemoveAnnotRaw: [['number', 'number', 'number'] as const, 'boolean'] as const,
  EPDFText_RedactInQuads: [
    ['number', 'number', 'number', 'boolean', 'boolean'] as const,
    'boolean',
  ] as const,
  EPDFText_RedactInRect: [['number', 'number', 'boolean', 'boolean'] as const, 'boolean'] as const,
  FORM_CanRedo: [['number', 'number'] as const, 'boolean'] as const,
  FORM_CanUndo: [['number', 'number'] as const, 'boolean'] as const,
  FORM_DoDocumentAAction: [['number', 'number'] as const, null] as const,
  FORM_DoDocumentJSAction: [['number'] as const, null] as const,
  FORM_DoDocumentOpenAction: [['number'] as const, null] as const,
  FORM_DoPageAAction: [['number', 'number', 'number'] as const, null] as const,
  FORM_ForceToKillFocus: [['number'] as const, 'boolean'] as const,
  FORM_GetFocusedAnnot: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FORM_GetFocusedText: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FORM_GetSelectedText: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FORM_IsIndexSelected: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FORM_OnAfterLoadPage: [['number', 'number'] as const, null] as const,
  FORM_OnBeforeClosePage: [['number', 'number'] as const, null] as const,
  FORM_OnChar: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FORM_OnFocus: [['number', 'number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FORM_OnKeyDown: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FORM_OnKeyUp: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FORM_OnLButtonDoubleClick: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnLButtonDown: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnLButtonUp: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnMouseMove: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnMouseWheel: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnRButtonDown: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_OnRButtonUp: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FORM_Redo: [['number', 'number'] as const, 'boolean'] as const,
  FORM_ReplaceAndKeepSelection: [['number', 'number', 'number'] as const, null] as const,
  FORM_ReplaceSelection: [['number', 'number', 'number'] as const, null] as const,
  FORM_SelectAllText: [['number', 'number'] as const, 'boolean'] as const,
  FORM_SetFocusedAnnot: [['number', 'number'] as const, 'boolean'] as const,
  FORM_SetIndexSelected: [['number', 'number', 'number', 'boolean'] as const, 'boolean'] as const,
  FORM_Undo: [['number', 'number'] as const, 'boolean'] as const,
  FPDF_AddInstalledFont: [['number', 'number', 'number'] as const, null] as const,
  FPDF_CloseDocument: [['number'] as const, null] as const,
  FPDF_ClosePage: [['number'] as const, null] as const,
  FPDF_CloseXObject: [['number'] as const, null] as const,
  FPDF_CopyViewerPreferences: [['number', 'number'] as const, 'boolean'] as const,
  FPDF_CountNamedDests: [['number'] as const, 'number'] as const,
  FPDF_CreateClipPath: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDF_CreateNewDocument: [[] as const, 'number'] as const,
  FPDF_DestroyClipPath: [['number'] as const, null] as const,
  FPDF_DestroyLibrary: [[] as const, null] as const,
  FPDF_DeviceToPage: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    'boolean',
  ] as const,
  FPDF_DocumentHasValidCrossReferenceTable: [['number'] as const, 'boolean'] as const,
  FPDF_FFLDraw: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    null,
  ] as const,
  FPDF_FreeDefaultSystemFontInfo: [['number'] as const, null] as const,
  FPDF_GetDefaultSystemFontInfo: [[] as const, 'number'] as const,
  FPDF_GetDefaultTTFMap: [[] as const, 'number'] as const,
  FPDF_GetDefaultTTFMapCount: [[] as const, 'number'] as const,
  FPDF_GetDefaultTTFMapEntry: [['number'] as const, 'number'] as const,
  FPDF_GetDocPermissions: [['number'] as const, 'number'] as const,
  FPDF_GetDocUserPermissions: [['number'] as const, 'number'] as const,
  FPDF_GetFileIdentifier: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDF_GetFileVersion: [['number', 'number'] as const, 'boolean'] as const,
  FPDF_GetFormType: [['number'] as const, 'number'] as const,
  FPDF_GetLastError: [[] as const, 'number'] as const,
  FPDF_GetMetaText: [['number', 'string', 'number', 'number'] as const, 'number'] as const,
  FPDF_GetNamedDest: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDF_GetNamedDestByName: [['number', 'string'] as const, 'number'] as const,
  FPDF_GetPageAAction: [['number', 'number'] as const, 'number'] as const,
  FPDF_GetPageBoundingBox: [['number', 'number'] as const, 'boolean'] as const,
  FPDF_GetPageCount: [['number'] as const, 'number'] as const,
  FPDF_GetPageHeight: [['number'] as const, 'number'] as const,
  FPDF_GetPageHeightF: [['number'] as const, 'number'] as const,
  FPDF_GetPageLabel: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDF_GetPageSizeByIndex: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDF_GetPageSizeByIndexF: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDF_GetPageWidth: [['number'] as const, 'number'] as const,
  FPDF_GetPageWidthF: [['number'] as const, 'number'] as const,
  FPDF_GetSecurityHandlerRevision: [['number'] as const, 'number'] as const,
  FPDF_GetSignatureCount: [['number'] as const, 'number'] as const,
  FPDF_GetSignatureObject: [['number', 'number'] as const, 'number'] as const,
  FPDF_GetTrailerEnds: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_GetXFAPacketContent: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDF_GetXFAPacketCount: [['number'] as const, 'number'] as const,
  FPDF_GetXFAPacketName: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDF_ImportNPagesToOne: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDF_ImportPages: [['number', 'number', 'string', 'number'] as const, 'boolean'] as const,
  FPDF_ImportPagesByIndex: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDF_InitLibrary: [[] as const, null] as const,
  FPDF_InitLibraryWithConfig: [['number'] as const, null] as const,
  FPDF_LoadCustomDocument: [['number', 'string'] as const, 'number'] as const,
  FPDF_LoadDocument: [['number', 'string'] as const, 'number'] as const,
  FPDF_LoadMemDocument: [['number', 'number', 'string'] as const, 'number'] as const,
  FPDF_LoadMemDocument64: [['number', 'number', 'string'] as const, 'number'] as const,
  FPDF_LoadPage: [['number', 'number'] as const, 'number'] as const,
  FPDF_LoadXFA: [['number'] as const, 'boolean'] as const,
  FPDF_MovePages: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDF_NewFormObjectFromXObject: [['number'] as const, 'number'] as const,
  FPDF_NewXObjectFromPage: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_PageToDevice: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    'boolean',
  ] as const,
  FPDF_RemoveFormFieldHighlight: [['number'] as const, null] as const,
  FPDF_RenderPage_Close: [['number'] as const, null] as const,
  FPDF_RenderPage_Continue: [['number', 'number'] as const, 'number'] as const,
  FPDF_RenderPageBitmap: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDF_RenderPageBitmap_Start: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    'number',
  ] as const,
  FPDF_RenderPageBitmapWithColorScheme_Start: [
    [
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
      'number',
    ] as const,
    'number',
  ] as const,
  FPDF_RenderPageBitmapWithMatrix: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDF_SaveAsCopy: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDF_SaveWithVersion: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDF_SetFormFieldHighlightAlpha: [['number', 'number'] as const, null] as const,
  FPDF_SetFormFieldHighlightColor: [['number', 'number', 'number'] as const, null] as const,
  FPDF_SetSandBoxPolicy: [['number', 'boolean'] as const, null] as const,
  FPDF_SetSystemFontInfo: [['number'] as const, null] as const,
  FPDF_StructElement_Attr_CountChildren: [['number'] as const, 'number'] as const,
  FPDF_StructElement_Attr_GetBlobValue: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDF_StructElement_Attr_GetBooleanValue: [['number', 'number'] as const, 'boolean'] as const,
  FPDF_StructElement_Attr_GetChildAtIndex: [['number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_Attr_GetCount: [['number'] as const, 'number'] as const,
  FPDF_StructElement_Attr_GetName: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDF_StructElement_Attr_GetNumberValue: [['number', 'number'] as const, 'boolean'] as const,
  FPDF_StructElement_Attr_GetStringValue: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDF_StructElement_Attr_GetType: [['number'] as const, 'number'] as const,
  FPDF_StructElement_Attr_GetValue: [['number', 'string'] as const, 'number'] as const,
  FPDF_StructElement_CountChildren: [['number'] as const, 'number'] as const,
  FPDF_StructElement_GetActualText: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetAltText: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetAttributeAtIndex: [['number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetAttributeCount: [['number'] as const, 'number'] as const,
  FPDF_StructElement_GetChildAtIndex: [['number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetChildMarkedContentID: [['number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetID: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetLang: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetMarkedContentID: [['number'] as const, 'number'] as const,
  FPDF_StructElement_GetMarkedContentIdAtIndex: [['number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetMarkedContentIdCount: [['number'] as const, 'number'] as const,
  FPDF_StructElement_GetObjType: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetParent: [['number'] as const, 'number'] as const,
  FPDF_StructElement_GetStringAttribute: [
    ['number', 'string', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDF_StructElement_GetTitle: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_StructElement_GetType: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDF_StructTree_Close: [['number'] as const, null] as const,
  FPDF_StructTree_CountChildren: [['number'] as const, 'number'] as const,
  FPDF_StructTree_GetChildAtIndex: [['number', 'number'] as const, 'number'] as const,
  FPDF_StructTree_GetForPage: [['number'] as const, 'number'] as const,
  FPDF_VIEWERREF_GetDuplex: [['number'] as const, 'number'] as const,
  FPDF_VIEWERREF_GetName: [['number', 'string', 'number', 'number'] as const, 'number'] as const,
  FPDF_VIEWERREF_GetNumCopies: [['number'] as const, 'number'] as const,
  FPDF_VIEWERREF_GetPrintPageRange: [['number'] as const, 'number'] as const,
  FPDF_VIEWERREF_GetPrintPageRangeCount: [['number'] as const, 'number'] as const,
  FPDF_VIEWERREF_GetPrintPageRangeElement: [['number', 'number'] as const, 'number'] as const,
  FPDF_VIEWERREF_GetPrintScaling: [['number'] as const, 'boolean'] as const,
  FPDFAction_GetDest: [['number', 'number'] as const, 'number'] as const,
  FPDFAction_GetFilePath: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFAction_GetType: [['number'] as const, 'number'] as const,
  FPDFAction_GetURIPath: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFAnnot_AddFileAttachment: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_AddInkStroke: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFAnnot_AppendAttachmentPoints: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_AppendObject: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_CountAttachmentPoints: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetAP: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetAttachmentPoints: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetBorder: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetColor: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFAnnot_GetFileAttachment: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetFlags: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetFocusableSubtypes: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetFocusableSubtypesCount: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetFontColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFAnnot_GetFontSize: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetFormAdditionalActionJavaScript: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormControlCount: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetFormControlIndex: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetFormFieldAlternateName: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormFieldAtPoint: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetFormFieldExportValue: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormFieldFlags: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetFormFieldName: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetFormFieldType: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetFormFieldValue: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetInkListCount: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetInkListPath: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetLine: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetLink: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetLinkedAnnot: [['number', 'string'] as const, 'number'] as const,
  FPDFAnnot_GetNumberValue: [['number', 'string', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetObject: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetObjectCount: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetOptionCount: [['number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetOptionLabel: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAnnot_GetRect: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_GetStringValue: [['number', 'string', 'number', 'number'] as const, 'number'] as const,
  FPDFAnnot_GetSubtype: [['number'] as const, 'number'] as const,
  FPDFAnnot_GetValueType: [['number', 'string'] as const, 'number'] as const,
  FPDFAnnot_GetVertices: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFAnnot_HasAttachmentPoints: [['number'] as const, 'boolean'] as const,
  FPDFAnnot_HasKey: [['number', 'string'] as const, 'boolean'] as const,
  FPDFAnnot_IsChecked: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_IsObjectSupportedSubtype: [['number'] as const, 'boolean'] as const,
  FPDFAnnot_IsOptionSelected: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_IsSupportedSubtype: [['number'] as const, 'boolean'] as const,
  FPDFAnnot_RemoveInkList: [['number'] as const, 'boolean'] as const,
  FPDFAnnot_RemoveObject: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetAP: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetAttachmentPoints: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetBorder: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetColor: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFAnnot_SetFlags: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetFocusableSubtypes: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetFontColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFAnnot_SetFormFieldFlags: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetRect: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetStringValue: [['number', 'string', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_SetURI: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAnnot_UpdateObject: [['number', 'number'] as const, 'boolean'] as const,
  FPDFAttachment_GetFile: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAttachment_GetName: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFAttachment_GetStringValue: [
    ['number', 'string', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFAttachment_GetSubtype: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFAttachment_GetValueType: [['number', 'string'] as const, 'number'] as const,
  FPDFAttachment_HasKey: [['number', 'string'] as const, 'boolean'] as const,
  FPDFAttachment_SetFile: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFAttachment_SetStringValue: [['number', 'string', 'number'] as const, 'boolean'] as const,
  FPDFAvail_Create: [['number', 'number'] as const, 'number'] as const,
  FPDFAvail_Destroy: [['number'] as const, null] as const,
  FPDFAvail_GetDocument: [['number', 'string'] as const, 'number'] as const,
  FPDFAvail_GetFirstPageNum: [['number'] as const, 'number'] as const,
  FPDFAvail_IsDocAvail: [['number', 'number'] as const, 'number'] as const,
  FPDFAvail_IsFormAvail: [['number', 'number'] as const, 'number'] as const,
  FPDFAvail_IsLinearized: [['number'] as const, 'number'] as const,
  FPDFAvail_IsPageAvail: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFBitmap_Create: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFBitmap_CreateEx: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFBitmap_Destroy: [['number'] as const, null] as const,
  FPDFBitmap_FillRect: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFBitmap_GetBuffer: [['number'] as const, 'number'] as const,
  FPDFBitmap_GetFormat: [['number'] as const, 'number'] as const,
  FPDFBitmap_GetHeight: [['number'] as const, 'number'] as const,
  FPDFBitmap_GetStride: [['number'] as const, 'number'] as const,
  FPDFBitmap_GetWidth: [['number'] as const, 'number'] as const,
  FPDFBookmark_Find: [['number', 'number'] as const, 'number'] as const,
  FPDFBookmark_GetAction: [['number'] as const, 'number'] as const,
  FPDFBookmark_GetCount: [['number'] as const, 'number'] as const,
  FPDFBookmark_GetDest: [['number', 'number'] as const, 'number'] as const,
  FPDFBookmark_GetFirstChild: [['number', 'number'] as const, 'number'] as const,
  FPDFBookmark_GetNextSibling: [['number', 'number'] as const, 'number'] as const,
  FPDFBookmark_GetTitle: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFCatalog_GetLanguage: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFCatalog_IsTagged: [['number'] as const, 'boolean'] as const,
  FPDFCatalog_SetLanguage: [['number', 'number'] as const, 'boolean'] as const,
  FPDFClipPath_CountPaths: [['number'] as const, 'number'] as const,
  FPDFClipPath_CountPathSegments: [['number', 'number'] as const, 'number'] as const,
  FPDFClipPath_GetPathSegment: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFDest_GetDestPageIndex: [['number', 'number'] as const, 'number'] as const,
  FPDFDest_GetLocationInPage: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFDest_GetView: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFDoc_AddAttachment: [['number', 'number'] as const, 'number'] as const,
  FPDFDoc_CloseJavaScriptAction: [['number'] as const, null] as const,
  FPDFDoc_DeleteAttachment: [['number', 'number'] as const, 'boolean'] as const,
  FPDFDOC_ExitFormFillEnvironment: [['number'] as const, null] as const,
  FPDFDoc_GetAttachment: [['number', 'number'] as const, 'number'] as const,
  FPDFDoc_GetAttachmentCount: [['number'] as const, 'number'] as const,
  FPDFDoc_GetJavaScriptAction: [['number', 'number'] as const, 'number'] as const,
  FPDFDoc_GetJavaScriptActionCount: [['number'] as const, 'number'] as const,
  FPDFDoc_GetPageMode: [['number'] as const, 'number'] as const,
  FPDFDOC_InitFormFillEnvironment: [['number', 'number'] as const, 'number'] as const,
  FPDFFont_Close: [['number'] as const, null] as const,
  FPDFFont_GetAscent: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFFont_GetBaseFontName: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFFont_GetDescent: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFFont_GetFamilyName: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFFont_GetFlags: [['number'] as const, 'number'] as const,
  FPDFFont_GetFontData: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFFont_GetGlyphPath: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFFont_GetGlyphWidth: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFFont_GetIsEmbedded: [['number'] as const, 'number'] as const,
  FPDFFont_GetItalicAngle: [['number', 'number'] as const, 'boolean'] as const,
  FPDFFont_GetWeight: [['number'] as const, 'number'] as const,
  FPDFFormObj_CountObjects: [['number'] as const, 'number'] as const,
  FPDFFormObj_GetObject: [['number', 'number'] as const, 'number'] as const,
  FPDFFormObj_RemoveObject: [['number', 'number'] as const, 'boolean'] as const,
  FPDFGlyphPath_CountGlyphSegments: [['number'] as const, 'number'] as const,
  FPDFGlyphPath_GetGlyphPathSegment: [['number', 'number'] as const, 'number'] as const,
  FPDFImageObj_GetBitmap: [['number'] as const, 'number'] as const,
  FPDFImageObj_GetIccProfileDataDecoded: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFImageObj_GetImageDataDecoded: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFImageObj_GetImageDataRaw: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFImageObj_GetImageFilter: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFImageObj_GetImageFilterCount: [['number'] as const, 'number'] as const,
  FPDFImageObj_GetImageMetadata: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFImageObj_GetImagePixelSize: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFImageObj_GetRenderedBitmap: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFImageObj_LoadJpegFile: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFImageObj_LoadJpegFileInline: [
    ['number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFImageObj_SetBitmap: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFImageObj_SetMatrix: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFJavaScriptAction_GetName: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFJavaScriptAction_GetScript: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFLink_CloseWebLinks: [['number'] as const, null] as const,
  FPDFLink_CountQuadPoints: [['number'] as const, 'number'] as const,
  FPDFLink_CountRects: [['number', 'number'] as const, 'number'] as const,
  FPDFLink_CountWebLinks: [['number'] as const, 'number'] as const,
  FPDFLink_Enumerate: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFLink_GetAction: [['number'] as const, 'number'] as const,
  FPDFLink_GetAnnot: [['number', 'number'] as const, 'number'] as const,
  FPDFLink_GetAnnotRect: [['number', 'number'] as const, 'boolean'] as const,
  FPDFLink_GetDest: [['number', 'number'] as const, 'number'] as const,
  FPDFLink_GetLinkAtPoint: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFLink_GetLinkZOrderAtPoint: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFLink_GetQuadPoints: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFLink_GetRect: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFLink_GetTextRange: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFLink_GetURL: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFLink_LoadWebLinks: [['number'] as const, 'number'] as const,
  FPDFPage_CloseAnnot: [['number'] as const, null] as const,
  FPDFPage_CountObjects: [['number'] as const, 'number'] as const,
  FPDFPage_CreateAnnot: [['number', 'number'] as const, 'number'] as const,
  FPDFPage_Delete: [['number', 'number'] as const, null] as const,
  FPDFPage_Flatten: [['number', 'number'] as const, 'number'] as const,
  FPDFPage_FormFieldZOrderAtPoint: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFPage_GenerateContent: [['number'] as const, 'boolean'] as const,
  FPDFPage_GetAnnot: [['number', 'number'] as const, 'number'] as const,
  FPDFPage_GetAnnotCount: [['number'] as const, 'number'] as const,
  FPDFPage_GetAnnotIndex: [['number', 'number'] as const, 'number'] as const,
  FPDFPage_GetArtBox: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPage_GetBleedBox: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPage_GetCropBox: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPage_GetDecodedThumbnailData: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFPage_GetMediaBox: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPage_GetObject: [['number', 'number'] as const, 'number'] as const,
  FPDFPage_GetRawThumbnailData: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFPage_GetRotation: [['number'] as const, 'number'] as const,
  FPDFPage_GetThumbnailAsBitmap: [['number'] as const, 'number'] as const,
  FPDFPage_GetTrimBox: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPage_HasFormFieldAtPoint: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFPage_HasTransparency: [['number'] as const, 'boolean'] as const,
  FPDFPage_InsertClipPath: [['number', 'number'] as const, null] as const,
  FPDFPage_InsertObject: [['number', 'number'] as const, null] as const,
  FPDFPage_InsertObjectAtIndex: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPage_New: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFPage_RemoveAnnot: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPage_RemoveObject: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPage_SetArtBox: [['number', 'number', 'number', 'number', 'number'] as const, null] as const,
  FPDFPage_SetBleedBox: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDFPage_SetCropBox: [['number', 'number', 'number', 'number', 'number'] as const, null] as const,
  FPDFPage_SetMediaBox: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDFPage_SetRotation: [['number', 'number'] as const, null] as const,
  FPDFPage_SetTrimBox: [['number', 'number', 'number', 'number', 'number'] as const, null] as const,
  FPDFPage_TransformAnnots: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDFPage_TransFormWithClip: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_AddMark: [['number', 'string'] as const, 'number'] as const,
  FPDFPageObj_CountMarks: [['number'] as const, 'number'] as const,
  FPDFPageObj_CreateNewPath: [['number', 'number'] as const, 'number'] as const,
  FPDFPageObj_CreateNewRect: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFPageObj_CreateTextObj: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFPageObj_Destroy: [['number'] as const, null] as const,
  FPDFPageObj_GetBounds: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObj_GetClipPath: [['number'] as const, 'number'] as const,
  FPDFPageObj_GetDashArray: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_GetDashCount: [['number'] as const, 'number'] as const,
  FPDFPageObj_GetDashPhase: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_GetFillColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObj_GetIsActive: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_GetLineCap: [['number'] as const, 'number'] as const,
  FPDFPageObj_GetLineJoin: [['number'] as const, 'number'] as const,
  FPDFPageObj_GetMark: [['number', 'number'] as const, 'number'] as const,
  FPDFPageObj_GetMarkedContentID: [['number'] as const, 'number'] as const,
  FPDFPageObj_GetMatrix: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_GetRotatedBounds: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_GetStrokeColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObj_GetStrokeWidth: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_GetType: [['number'] as const, 'number'] as const,
  FPDFPageObj_HasTransparency: [['number'] as const, 'boolean'] as const,
  FPDFPageObj_NewImageObj: [['number'] as const, 'number'] as const,
  FPDFPageObj_NewTextObj: [['number', 'string', 'number'] as const, 'number'] as const,
  FPDFPageObj_RemoveMark: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_SetBlendMode: [['number', 'string'] as const, null] as const,
  FPDFPageObj_SetDashArray: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_SetDashPhase: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_SetFillColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObj_SetIsActive: [['number', 'boolean'] as const, 'boolean'] as const,
  FPDFPageObj_SetLineCap: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_SetLineJoin: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_SetMatrix: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_SetStrokeColor: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObj_SetStrokeWidth: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObj_Transform: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDFPageObj_TransformClipPath: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    null,
  ] as const,
  FPDFPageObj_TransformF: [['number', 'number'] as const, 'boolean'] as const,
  FPDFPageObjMark_CountParams: [['number'] as const, 'number'] as const,
  FPDFPageObjMark_GetName: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPageObjMark_GetParamBlobValue: [
    ['number', 'string', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObjMark_GetParamFloatValue: [['number', 'string', 'number'] as const, 'boolean'] as const,
  FPDFPageObjMark_GetParamIntValue: [['number', 'string', 'number'] as const, 'boolean'] as const,
  FPDFPageObjMark_GetParamKey: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObjMark_GetParamStringValue: [
    ['number', 'string', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObjMark_GetParamValueType: [['number', 'string'] as const, 'number'] as const,
  FPDFPageObjMark_RemoveParam: [['number', 'number', 'string'] as const, 'boolean'] as const,
  FPDFPageObjMark_SetBlobParam: [
    ['number', 'number', 'number', 'string', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObjMark_SetFloatParam: [
    ['number', 'number', 'number', 'string', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObjMark_SetIntParam: [
    ['number', 'number', 'number', 'string', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPageObjMark_SetStringParam: [
    ['number', 'number', 'number', 'string', 'string'] as const,
    'boolean',
  ] as const,
  FPDFPath_BezierTo: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFPath_Close: [['number'] as const, 'boolean'] as const,
  FPDFPath_CountSegments: [['number'] as const, 'number'] as const,
  FPDFPath_GetDrawMode: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPath_GetPathSegment: [['number', 'number'] as const, 'number'] as const,
  FPDFPath_LineTo: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPath_MoveTo: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPath_SetDrawMode: [['number', 'number', 'boolean'] as const, 'boolean'] as const,
  FPDFPathSegment_GetClose: [['number'] as const, 'boolean'] as const,
  FPDFPathSegment_GetPoint: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFPathSegment_GetType: [['number'] as const, 'number'] as const,
  FPDFSignatureObj_GetByteRange: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFSignatureObj_GetContents: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFSignatureObj_GetDocMDPPermission: [['number'] as const, 'number'] as const,
  FPDFSignatureObj_GetReason: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFSignatureObj_GetSubFilter: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFSignatureObj_GetTime: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFText_ClosePage: [['number'] as const, null] as const,
  FPDFText_CountChars: [['number'] as const, 'number'] as const,
  FPDFText_CountRects: [['number', 'number', 'number'] as const, 'number'] as const,
  FPDFText_FindClose: [['number'] as const, null] as const,
  FPDFText_FindNext: [['number'] as const, 'boolean'] as const,
  FPDFText_FindPrev: [['number'] as const, 'boolean'] as const,
  FPDFText_FindStart: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFText_GetBoundedText: [
    ['number', 'number', 'number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_GetCharAngle: [['number', 'number'] as const, 'number'] as const,
  FPDFText_GetCharBox: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFText_GetCharIndexAtPos: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_GetCharIndexFromTextIndex: [['number', 'number'] as const, 'number'] as const,
  FPDFText_GetCharOrigin: [['number', 'number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFText_GetFillColor: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFText_GetFontInfo: [
    ['number', 'number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_GetFontSize: [['number', 'number'] as const, 'number'] as const,
  FPDFText_GetFontWeight: [['number', 'number'] as const, 'number'] as const,
  FPDFText_GetLooseCharBox: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFText_GetMatrix: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFText_GetRect: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFText_GetSchCount: [['number'] as const, 'number'] as const,
  FPDFText_GetSchResultIndex: [['number'] as const, 'number'] as const,
  FPDFText_GetStrokeColor: [
    ['number', 'number', 'number', 'number', 'number', 'number'] as const,
    'boolean',
  ] as const,
  FPDFText_GetText: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFText_GetTextIndexFromCharIndex: [['number', 'number'] as const, 'number'] as const,
  FPDFText_GetTextObject: [['number', 'number'] as const, 'number'] as const,
  FPDFText_GetUnicode: [['number', 'number'] as const, 'number'] as const,
  FPDFText_HasUnicodeMapError: [['number', 'number'] as const, 'number'] as const,
  FPDFText_IsGenerated: [['number', 'number'] as const, 'number'] as const,
  FPDFText_IsHyphen: [['number', 'number'] as const, 'number'] as const,
  FPDFText_LoadCidType2Font: [
    ['number', 'number', 'number', 'string', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFText_LoadFont: [
    ['number', 'number', 'number', 'number', 'boolean'] as const,
    'number',
  ] as const,
  FPDFText_LoadPage: [['number'] as const, 'number'] as const,
  FPDFText_LoadStandardFont: [['number', 'string'] as const, 'number'] as const,
  FPDFText_SetCharcodes: [['number', 'number', 'number'] as const, 'boolean'] as const,
  FPDFText_SetText: [['number', 'number'] as const, 'boolean'] as const,
  FPDFTextObj_GetFont: [['number'] as const, 'number'] as const,
  FPDFTextObj_GetFontSize: [['number', 'number'] as const, 'boolean'] as const,
  FPDFTextObj_GetRenderedBitmap: [
    ['number', 'number', 'number', 'number'] as const,
    'number',
  ] as const,
  FPDFTextObj_GetText: [['number', 'number', 'number', 'number'] as const, 'number'] as const,
  FPDFTextObj_GetTextRenderMode: [['number'] as const, 'number'] as const,
  FPDFTextObj_SetTextRenderMode: [['number', 'number'] as const, 'boolean'] as const,
  PDFiumExt_CloseFileWriter: [['number'] as const, null] as const,
  PDFiumExt_CloseFormFillInfo: [['number'] as const, null] as const,
  PDFiumExt_ExitFormFillEnvironment: [['number'] as const, null] as const,
  PDFiumExt_GetFileWriterData: [['number', 'number', 'number'] as const, 'number'] as const,
  PDFiumExt_GetFileWriterSize: [['number'] as const, 'number'] as const,
  PDFiumExt_Init: [[] as const, null] as const,
  PDFiumExt_InitFormFillEnvironment: [['number', 'number'] as const, 'number'] as const,
  PDFiumExt_OpenFileWriter: [[] as const, 'number'] as const,
  PDFiumExt_OpenFormFillInfo: [[] as const, 'number'] as const,
  PDFiumExt_SaveAsCopy: [['number', 'number'] as const, 'number'] as const,
} as const;
